import { GET_FIREBASE_DATA } from "../constants/langCaptConstants";


export const saveCaptionReducer = (state = {caption: []}, action) => {
    switch (action.type) {
        case GET_FIREBASE_DATA:
            return {
                caption: [...state.caption, action.payload]
            }

        default:
            return state
    }
}